import { createApiClient } from 'utils/createApiClient'
import { createContentfulClient } from 'utils/createContentfulClient'

export const ApiClient = createApiClient(process.env.NEXT_PUBLIC_API_URL!)

export const contentfulClient = createContentfulClient()
